module.exports = __webpack_public_path__ + "static/img/15.67f167a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/15.png
// module id = DGX9
// module chunks = 0